import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { PolicyWrapper, ProtocolsCTAs, BottomCTAsWrapper } from "./styles";
import { Fragment } from "react";
import parse from "html-react-parser";
import { useHistory } from "react-router";
import routes from "constants/routes";



const NoticeLegalPage = ({ selectedLang, token }) => {
  const history = useHistory();
  const [content, setContent] = useState("");
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ANTIAGING_API}api/antiaging/pages`, {
        headers: {
          "Content-Language": selectedLang,
          Authorization: `Bearer ${token}`,
        },
        params: { identifier: "legal-notice" },
      })
      .then(({ data }) => setContent(data.results))
      .catch(console.error);
  }, [token, selectedLang]);
  return (
    <Fragment>
      <PolicyWrapper>

        {parse(content)}
      </PolicyWrapper>

      <BottomCTAsWrapper>
        <ProtocolsCTAs 
          protocolId={true} 
          onClick={() => history.push(`${routes.homeAntiaging}`)} 
          >home
        </ProtocolsCTAs>
      </BottomCTAsWrapper>
      </Fragment>

  )

};


const mapStateToProps = (state) => ({
  token: state.user.data.api_token,
  selectedLang: state.languages.selectedLanguage,
});

export default connect(mapStateToProps, null)(NoticeLegalPage);